import script from "./Rule1Nimetav.vue?vue&type=script&setup=true&lang=ts"
export * from "./Rule1Nimetav.vue?vue&type=script&setup=true&lang=ts"

import "./Rule1Nimetav.vue?vue&type=style&index=0&id=6a9349e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a9349e8"]])

export default __exports__